module.exports = __webpack_public_path__ + "img/008.01be4298.svg";